import shopifyEnterpriseDefaults from '../shopify-enterprise-generic/config.js';

function InitFunc() {
  shopifyEnterpriseDefaults.InitFunc?.();

  if (window.document.querySelector('#cm_results, #cm-brand-list, #cm_manufacturers')) {
    const unwantedPageWrappers = [['.page__content.rte', 'reading-width', 'rte']];

    unwantedPageWrappers.forEach(([elemSelector, ...classNames]) => {
      const wrapperElem = window.document.querySelector(elemSelector);
      wrapperElem?.classList.remove(...classNames);
    });
  }
}

export default {
  ...shopifyEnterpriseDefaults,
  InitFunc,
  includes: ['shopify-enterprise-generic'],
  Widgets: [
    ...shopifyEnterpriseDefaults.Widgets,
    {
      name: 'FilterSearchBox',
    },
  ],
};
